<template>
	<div class="offer-list-item-list">
		<template v-if="loading">
			<Loading
				size="small"
				class="offer-list-item-list__loader"
			/>
		</template>

		<template v-else>
			<OfferVerified
				v-for="(item, index) of items"
				:key="`${item.OfferID}${index}`"
				:auto-details="index === 0"
				:offer-data="item"
				:hotel-data="hotelData"
				:client="client"
				:is-verified="!!item.availableChecked"
				class="offer-list-item-list__item"
				@verify-offer="onFetchDetails(item, index)"
			/>
		</template>
	</div>
</template>

<script lang="ts" setup>
import Loading from '@lmt-rpb/Loading/Loading.vue';
import type { MergedOfferItemData } from '@interfaces/offer';
import type { OfferListTypoHotelData } from '@interfaces/offer-list-types/offer-list-typo-hotel-data';
import type { ClientType } from '@/interfaces/common';
import OfferVerified from '@lmt-rpb/OfferVerified/OfferVerified.vue';

interface Props {
	items: MergedOfferItemData[];
	loading?: boolean;
	client?: ClientType;
	hotelData: OfferListTypoHotelData;
}

withDefaults(defineProps<Props>(), {
	loading: false,
	client: 'at',
});

const emit = defineEmits(['OfferListItem:FetchDetails']);

const onFetchDetails = (item: MergedOfferItemData, index: number) => {
	if (item.available && !item.availableChecked) {
		item.availableChecked = true;
	}

	emit('OfferListItem:FetchDetails', item, index);
};
</script>

<style lang="scss" scoped>
.offer-list-item-list {
	margin-top: 2.5rem;

	.offer-list-item-list__loader {
		margin: 5rem auto;
	}

	.offer-list-item-list__item {
		margin-bottom: 2rem;
		min-height: 15rem;
		background: white;
	}
}
</style>
